module.exports = __webpack_public_path__ + "img/icon_grid_plus_on.d603d753.svg";